
<div id="toggle-cpt-dropdown" (click)="showCptDropdown = !showCptDropdown">E & M Distribution
  <span id="cpt-selection-label">{{selectedCpt?.text || ''}} <i class="fa fa-caret-down"></i></span>
  <div id="cpt-dropdown" *ngIf="showCptDropdown">
      <span *ngFor="let cpt of cptCodeSelections" class="cpt-item" [class.selected]="cpt.text === selectedCpt?.text ||
     ''" (click)="onCptSelected(cpt)">{{cpt.text}}</span>
  </div>
</div>
